import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
    paddingRight: 0,
  },
  rightColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },

  about: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: 20,
    marginBottom: 40,
    width: '90%',
  },
  citationWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  citation: {
    fontFamily: 'Lato',
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'center',
  },
  speakerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
  },
  getReady: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 400,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    textTransform: 'uppercase',
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 400,
  },

  statisticsGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 20,
    rowGap: 20,
    width: '100%',
    paddingRight: 53,
  },
  statisticsItem: {
    width: '33%',
    flexDirection: 'row',
    gap: 5,
  },
  icon: {
    color: '#27343d',
    fontFamily: 'FontAwesome',
    fontSize: 16,
  },
  iconWhite: {
    color: 'white',
    fontFamily: 'FontAwesome',
    fontSize: 16,
  },
  textWrapper: {
    flex: 1,
  },
  statTitle: {
    color: '#27343d',
    fontSize: 20,
    fontWeight: 700,
    fontFamily: 'Lato',
  },
  statDescription: {
    color: '#27343d',
    fontSize: 16,
    fontWeight: 400,
    fontFamily: 'Lato',
  },

  // TARGET GROUPS
  targetGroupsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '100%',
    paddingTop: 30,
    gap: 20,
  },
  targetGroupsItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '297px',
  },
  targetGroupsHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
  },
  columnTitle: {
    color: 'white',
    fontWeight: 700,
    fontSize: 18,
    fontFamily: 'Lato',
  },
  smallText: {
    color: 'white',
    fontWeight: 400,
    fontSize: 14,
    fontFamily: 'Lato',
  },
  progressBarContainer: {
    width: '100%',
    height: 10,
    backgroundColor: '#eee',
    borderRadius: 3,
    marginTop: 2,
    padding: 2,
  },
  progressBarFill: {
    height: '100%',
    borderRadius: 3,
  },
  rowSpaceBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
